export const ClientChoiceOptions = { '': '', accept: 'Accept', reject: 'Reject', ownchoice: 'Own Choice', kiv: 'KIV' } as const
